import { render, staticRenderFns } from "./mealPos.vue?vue&type=template&id=6436a2b6&scoped=true"
import script from "./mealPos.vue?vue&type=script&lang=js"
export * from "./mealPos.vue?vue&type=script&lang=js"
import style0 from "./mealPos.vue?vue&type=style&index=0&id=6436a2b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6436a2b6",
  null
  
)

export default component.exports